import { openDB } from 'idb';

const DB_NAME = 'image-cache-db';
const STORE_NAME = 'images';

const dbPromise = openDB(DB_NAME, 1, {
    upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
            db.createObjectStore(STORE_NAME);
        }
    },
});

export default {
    async getImage(url) {
        if (!url) return null;
        const db = await dbPromise;
        const blob = await db.get(STORE_NAME, url);
        if (blob) {
            return URL.createObjectURL(blob);
        }
        return null;
    },

    async saveImage(url, blob) {
        if (!url || !blob) return;
        const db = await dbPromise;
        await db.put(STORE_NAME, blob, url);
    },

    async fetchAndCacheImage(url) {
        try {
            const cached = await this.getImage(url);
            if (cached) return cached;

            const response = await fetch(url, { mode: 'cors' });
            if (!response.ok) throw new Error('Network response was not ok');

            const blob = await response.blob();
            await this.saveImage(url, blob);

            return URL.createObjectURL(blob);
        } catch (error) {
            console.warn(`[ImageCache] Failed to fetch ${url}`, error);
            return url;
        }
    }
};
